import {createRouter, createWebHistory, createWebHashHistory} from 'vue-router'
import installStripUnknownParams from '@/router/stripUnknownParams'
import {getRoutes} from './routes'
import {Store} from '@/store/app'

const history = process.env.VUE_APP_ROUTER_MODE === 'history'
  ? createWebHistory()
  : createWebHashHistory()

const router = createRouter({
  history,
  routes: getRoutes(Store),
  scrollBehavior: () => ({left: 0, top: 0}),
})

installStripUnknownParams(router)

export default router